import { Tab, Tabs } from '@mui/material'
import React from 'react'
import { a11yProps } from '../../../utils/a11yProps';
import styles from './globalTabStyle.module.css'

interface ITabList {
    name: string;
    id: number;
}

interface IGlobalTabProps {
    tabList: ITabList[];
    currentTab: number;
    ChangeTab: (event: React.SyntheticEvent, newValue: number) => void
}

export const GlobalTab = (props: IGlobalTabProps) => {
    const { currentTab, ChangeTab, tabList } = props;
    return (
        <>
            <Tabs
                value={currentTab}
                onChange={ChangeTab}
                aria-label="basic tabs"
                sx={{
                    "& .MuiTab-root": {
                        color: "#000",
                    },
                    "& .Mui-selected": {
                        color: "#3B78CE",
                    },
                    "& .MuiTabs-indicator": {
                        backgroundColor: "#3B78CE",
                        borderRadius: "5px 5px 0px 0px",
                    }
                }}
                className={styles.tabs}
            >
                {tabList.map((tabDetail, index) => (
                    <Tab key={index} className={styles.labelTxt} label={tabDetail.name} {...a11yProps(tabDetail.id)} />
                ))}
            </Tabs>
        </>
    )
}
